var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWasteRecycledIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 32C0 14.3269 14.3269 0 32 0C49.6731 0 64 14.3269 64 32C64 49.6731 49.6731 64 32 64C14.3269 64 0 49.6731 0 32Z",
    fill: "#00C950"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3337 41.3332H22.4203C21.9998 41.3344 21.586 41.2269 21.2192 41.0211C20.8525 40.8152 20.5451 40.5181 20.327 40.1585C20.1176 39.7973 20.0068 39.3874 20.0059 38.9699C20.0049 38.5524 20.1138 38.142 20.3217 37.7798L25.595 28.6665",
    stroke: "white",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.666 41.3331H41.6033C42.0219 41.3299 42.4326 41.219 42.7959 41.0112C43.1593 40.8034 43.463 40.5056 43.678 40.1465C43.8846 39.7863 43.9932 39.3783 43.9932 38.9631C43.9932 38.5479 43.8846 38.14 43.678 37.7798L42.0434 34.9531",
    stroke: "white",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.666 37.3335L30.666 41.3335L34.666 45.3335",
    stroke: "white",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0568 34.1278L25.5941 28.6665L20.1328 30.1305",
    stroke: "white",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.459 23.748L29.9163 21.2253C30.1256 20.8605 30.4256 20.556 30.7872 20.3413C31.1489 20.1266 31.5599 20.0091 31.9803 20C32.3976 19.9992 32.8077 20.1082 33.1695 20.316C33.5313 20.5239 33.8321 20.8232 34.0417 21.184L39.299 30.308",
    stroke: "white",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8379 28.844L39.2992 30.308L40.7619 24.8467",
    stroke: "white",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWasteRecycledIcon);
export default __webpack_public_path__ + "static/media/Waste Recycled-icon.abcc07b59e952abbce20bd2a55bd5bc3.svg";
export { ForwardRef as ReactComponent };